export default "__VITE_ASSET__41edc860__"